import { styled } from '@mui/material/styles';

export const Container = styled('div')(
    () => `
    @media (max-width: 1024px) {
        padding: 16px 0 0 0;
        flex: 1;
        min-height: 0;
        overflow: hidden;
    }
`,
);

export const EmptyLayout = styled('div')({
    paddingTop: 11,
    '@media (max-width: 1024px)': {
        paddingTop: 0,
    },
});

// Full-bleed layout: the negative margins cancel the page padding (13px top,
// 24px sides) so the rail, columns and their dividers run edge to edge from the
// top of the viewport to the bottom.
export const PageLayout = styled('div')({
    display: 'flex',
    minWidth: 0,
    margin: '-13px -24px 0 -24px',
    '@media (max-width: 1024px)': {
        margin: 0,
        height: '100%',
        minHeight: 0,
    },
});

export const PageGrid = styled('div', {
    shouldForwardProp: prop => prop !== 'contactIsOpen',
})(({ contactIsOpen }) => ({
    flex: 1,
    minWidth: 0,
    height: 'var(--100vh)',
    display: 'grid',
    // Columns touch (divider-only seams); when the drawer is open the thread width
    // reserves list width + the fixed drawer's width, since the grid reaches the
    // viewport edge the drawer overlaps it fully.
    gridTemplateColumns: contactIsOpen ? '360px calc(100% - 720px)' : '360px 1fr',
    transition: 'width 0.4s ease-in-out',
    gridTemplateRows: '1fr',
    '@media (max-width: 1480px)': {
        gridTemplateColumns: contactIsOpen ? '270px calc(100% - 540px)' : '360px 1fr',
    },
    '@media (max-width: 1280px)': {
        gridTemplateColumns: contactIsOpen ? '200px calc(100% - 400px)' : '360px 1fr',
    },
    '@media (max-width: 1024px)': {
        height: '100%',
        minHeight: 0,
    },
    '@media (max-width: 768px)': {
        gridTemplateColumns: '100%',
    },
}));
